import React, { useEffect, useState } from 'react';
import { UserLanguageContext } from './userLanguageContext';
import { LanguageType, ReactSimpleComponentProps } from '@/custom-types';

export const UserLanguageContextProvider: React.FC<ReactSimpleComponentProps> = ({ children }) => {
  const [userLanguage, setUserLanguage] = useState<LanguageType>('en');
  
  useEffect(() => {
    const browserLanguage = navigator.language || navigator.languages[0];

    if (browserLanguage.startsWith('es')) setUserLanguage('es')
    else setUserLanguage('en');
  }, []);
  
  return (
    <UserLanguageContext.Provider value={userLanguage}>
      {children}
    </UserLanguageContext.Provider>
  )
}